import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { PharmaIndustryPage } from "@/components/site/PharmaIndustryPage";
import { PHARMA_META_DESCRIPTION } from "@/content/meta/PharmaIndustryPage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/industries/pharma")({
  head: () => ({
    meta: [
      { title: "Pharma Media Monitoring & Analysis | Perceptica" },
      { name: "description", content: PHARMA_META_DESCRIPTION },
      { property: "og:title", content: "Pharma Media Monitoring & Analysis | Perceptica" },
      { property: "og:description", content: PHARMA_META_DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Pharma Media Monitoring & Analysis | Perceptica" },
      { name: "twitter:description", content: PHARMA_META_DESCRIPTION },
      { property: "og:url", content: "https://perceptica.com/industries/pharma" },
      ...ogImageMeta("en", "/industries/pharma"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/industries/pharma" }),
  }),
  component: PharmaIndustryPage,
});
